import { render, staticRenderFns } from "./SuClassifyMenu.vue?vue&type=template&id=c6474ff4&scoped=true&"
import script from "./SuClassifyMenu.vue?vue&type=script&lang=js&"
export * from "./SuClassifyMenu.vue?vue&type=script&lang=js&"
import style0 from "./SuClassifyMenu.vue?vue&type=style&index=0&id=c6474ff4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6474ff4",
  null
  
)

export default component.exports